const themes = {
  LIGHT: "light",
  DARK: "dark",
};

export default themes;
